import React from "react";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";

export default function ThePlan() {
  const navigate = useNavigate();

  const pStyle = { fontSize: 15, color: "#4A4A6A", lineHeight: 1.9, marginBottom: 16 };

  return (
    <div style={{ fontFamily: "var(--font-body)", background: "#F5F0E8", minHeight: "100vh", color: "#1A1A2E" }}>

      <style>{`
        .bp-header { padding: 56px 48px 48px; }
        .bp-section { max-width: 860px; margin: 0 auto; padding: 40px 48px 0; }
        .bp-card { background: #fff; border: 1px solid #EDE8DF; border-radius: 20px; padding: 40px 48px; }
        .bp-dark-card { background: #1B3A6B; border-radius: 20px; padding: 40px 48px; }
        .bp-phase-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 14px; margin-top: 24px; }
        .bp-cta { padding: 64px 48px; margin-top: 72px; }
        @media (max-width: 768px) {
          .bp-header { padding: 36px 20px 32px; }
          .bp-section { padding: 24px 20px 0; }
          .bp-card { padding: 24px 20px; border-radius: 16px; }
          .bp-dark-card { padding: 28px 20px; border-radius: 16px; }
          .bp-phase-grid { grid-template-columns: 1fr; }
          .bp-cta { padding: 48px 20px; margin-top: 40px; }
          .bp-cta button { width: 100%; }
        }
      `}</style>

      <Navbar />

      {/* HEADER */}
      <div className="bp-header" style={{ background: "#fff", borderBottom: "1px solid #EDE8DF", textAlign: "center" }}>
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          The Forge SA Model
        </div>
        <h1 style={{ fontSize: "clamp(28px, 5vw, 48px)", fontWeight: 900, color: "#1A1A2E", letterSpacing: "-0.02em", margin: "0 0 16px", lineHeight: 1.1 }}>
          From Vision <span style={{ color: "#1B3A6B" }}>to Reality.</span>
        </h1>
        <p style={{ fontSize: 15, color: "#888", lineHeight: 1.8, maxWidth: 560, margin: "0 auto" }}>
          This page explains exactly how Forge SA works in practice. Not the dream. The engine.
        </p>
      </div>

      {/* THE OPPORTUNITY */}
      <div className="bp-section">
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          The Opportunity
        </div>
        <div className="bp-card">
          <p style={pStyle}>South Africa has extraordinary people. Skilled, ambitious, resilient people in every province, every township, every rural community. What has often been missing is not the will to build, but the infrastructure to turn that will into something tangible and lasting.</p>
          <p style={pStyle}>Government has made significant strides in delivering services at scale. Infrastructure programmes, housing projects, social grants, and education initiatives have reached millions of South Africans. But the scale of the challenge means that community-level gaps remain, and those gaps are where Forge SA operates.</p>
          <p style={{ ...pStyle, fontSize: 16, fontWeight: 800, color: "#1B3A6B", marginBottom: 0 }}>Forge SA does not compete with government. It complements it. Where large-scale delivery leaves space, Forge SA helps communities fill it, transparently and accountably.</p>
        </div>
      </div>

      {/* WHY EXISTING PLATFORMS ARE NOT ENOUGH */}
      <div className="bp-section">
        <div style={{ display: "inline-block", background: "rgba(201,168,76,0.1)", border: "1px solid rgba(201,168,76,0.3)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#8a6a1a", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          The Gap in the Market
        </div>
        <div className="bp-card">
          <p style={pStyle}>Existing crowdfunding platforms are built for individual fundraisers, not communities. They collect money and trust the recipient to use it well. There is no verification, no staged releases, no independent oversight, and no requirement that the money stays in the community.</p>
          <p style={pStyle}>Stokvels are powerful but personal. They pool money and return it to members rather than building permanent community assets. What Forge SA builds does not end when the cycle does.</p>
          <p style={{ ...pStyle, marginBottom: 0 }}>Forge SA is the first South African platform specifically designed for community-owned development. Every rand is verified by Forge Vault. Every milestone is confirmed before payment. Every payment goes to a verified cooperative or worker, never to an individual. And every transaction is publicly visible.</p>
        </div>
      </div>

      {/* THE MODEL */}
      <div className="bp-section">
        <div style={{ display: "inline-block", background: "rgba(46,125,50,0.08)", border: "1px solid rgba(46,125,50,0.2)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#2E7D32", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          The Forge SA Model
        </div>
        <div className="bp-card">
          <p style={pStyle}>When a community identifies a need, whether a road that needs fixing, a school that needs equipment, young people who need job training, or families who need housing, they propose a project on Forge SA.</p>
          <p style={pStyle}>That project goes through a rigorous verification process. The community members behind it go through a background review. The budget is independently reviewed. The milestones are set in advance. Only then does it go live for contributions.</p>
          <p style={pStyle}>When South Africans contribute, their money does not go to Forge SA. It goes into a dedicated project bank account, governed by Forge Vault, our automated governance engine. No one can instruct a payment without proof of work and all Forge Vault rules being satisfied.</p>
          <p style={pStyle}>Here is what makes this model unique. The people who build the project are the same people who funded it. Forge SA helps community members with relevant skills form a registered cooperative. That cooperative does the work. The money stays in the community. When the project is done, the cooperative continues as an independent business, creating permanent jobs.</p>
          <p style={{ ...pStyle, fontSize: 16, fontWeight: 800, color: "#1B3A6B", marginBottom: 0 }}>This is not crowdfunding. This is collective ownership of development.</p>
        </div>
      </div>

      {/* FORGE VAULT */}
      <div className="bp-section">
        <div style={{ display: "inline-block", background: "rgba(91,155,213,0.1)", border: "1px solid rgba(91,155,213,0.3)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#185FA5", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          Forge Vault
        </div>
        <div className="bp-card">
          <p style={pStyle}>Forge Vault is Forge SA's automated governance engine. It is not a bank and does not hold or own money. Its purpose is to ensure every payment follows the project's published rules before it can be released.</p>
          <p style={pStyle}>Before any payment moves, Forge Vault automatically checks that the funding goal has been reached, the supplier is verified, the invoice matches the approved budget, all evidence has been submitted, the community has voted with 70% or more approval, and the project stages are being followed in the correct order.</p>
          <p style={pStyle}>Only when every single rule is satisfied does Forge Vault instruct the payment. No person makes this decision. The rules do.</p>
          <p style={{ ...pStyle, fontSize: 16, fontWeight: 800, color: "#1B3A6B", marginBottom: 0 }}>Nobody controls the money. The rules do. That is why it can be trusted.</p>
        </div>
      </div>

      {/* GOVERNANCE */}
      <div className="bp-section">
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          Governance and Accountability
        </div>
        <div className="bp-card">
          <p style={pStyle}>Forge SA is not controlled by any single person, including its founder. No individual can instruct Forge Vault to release funds. Every financial decision is governed by published rules, checked automatically, and every transaction is published on a public ledger.</p>
          <p style={pStyle}>The platform is designed to be incorruptible by structure, not just by intention. Fraud is made structurally difficult because no individual ever holds or controls project funds. Forge Vault records every rule check and every payment instruction permanently. If anything goes wrong, funds are frozen immediately and a full public report is published.</p>
          <p style={{ ...pStyle, marginBottom: 0 }}>This governance model makes Forge SA a platform that government agencies, corporate partners, and civic organisations can trust and work alongside. We welcome collaboration with any institution that shares our commitment to transparent, community-centred development.</p>
        </div>
      </div>

      {/* COLLABORATION */}
      <div className="bp-section">
        <div style={{ display: "inline-block", background: "rgba(201,168,76,0.1)", border: "1px solid rgba(201,168,76,0.3)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#8a6a1a", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          Working Together
        </div>
        <div className="bp-card">
          <p style={pStyle}>Forge SA is not built in isolation. We believe the most powerful outcomes happen when communities, government, and the private sector work toward the same goals with shared accountability.</p>
          <p style={pStyle}>Government departments looking to extend their reach into communities will find in Forge SA a verified, transparent channel where public or private funds can be directed to projects that are independently governed by Forge Vault and publicly tracked.</p>
          <p style={pStyle}>Corporate partners fulfilling their Social and Labour Plan or Corporate Social Investment commitments can use Forge SA to fund verified projects where every rand is publicly accounted for by Forge Vault, making compliance reporting straightforward and impact genuinely measurable.</p>
          <p style={{ ...pStyle, marginBottom: 0 }}>Our door is open to any institution, department, municipality or organisation that wants to invest in South African communities with full transparency and zero risk of funds disappearing.</p>
        </div>
      </div>

      {/* ROADMAP */}
      <div className="bp-section">
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          The Roadmap
        </div>
        <div className="bp-card">
          <p style={pStyle}>Forge SA is building in phases, starting with a single verified project as the foundation.</p>
          <div className="bp-phase-grid">
            {[
              {
                phase: "Phase 1",
                title: "Launch",
                color: "#C9A84C",
                points: [
                  "One verified launch project",
                  "Secure payment processing",
                  "Public contribution tracking",
                  "Forge Vault governance engine live",
                ],
              },
              {
                phase: "Phase 2",
                title: "Scale",
                color: "#1B3A6B",
                points: [
                  "Open Tier 2 community projects",
                  "Expand to all 9 provinces",
                  "Launch talent database",
                  "First cooperative formed",
                ],
              },
              {
                phase: "Phase 3",
                title: "Partner",
                color: "#2E7D32",
                points: [
                  "Government partnerships",
                  "Corporate CSI integration",
                  "Full Forge Vault automation via banking API",
                  "First completed project",
                ],
              },
            ].map((p, i) => (
              <div key={i} style={{ background: "#F5F0E8", border: `1px solid ${p.color}30`, borderRadius: 16, padding: 20 }}>
                <div style={{ fontSize: 10, fontWeight: 700, color: p.color, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 6 }}>{p.phase}</div>
                <div style={{ fontSize: 16, fontWeight: 900, color: "#1A1A2E", marginBottom: 14 }}>{p.title}</div>
                {p.points.map((point, j) => (
                  <div key={j} style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 8 }}>
                    <div style={{ width: 6, height: 6, borderRadius: "50%", background: p.color, flexShrink: 0, marginTop: 6 }} />
                    <div style={{ fontSize: 12, color: "#4A4A6A", lineHeight: 1.5 }}>{point}</div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CLOSING */}
      <div className="bp-section" style={{ paddingBottom: 0 }}>
        <div className="bp-dark-card">
          <p style={{ fontSize: 15, color: "rgba(184,212,232,0.9)", lineHeight: 1.9, marginBottom: 20 }}>
            South Africa does not have a shortage of passion, talent or ambition. What it needs is a system that channels those things into something permanent, verifiable and owned by the people who built it.
          </p>
          <p style={{ fontSize: 15, color: "rgba(184,212,232,0.9)", lineHeight: 1.9, marginBottom: 28 }}>
            Forge SA is that system. Forge Vault is the engine that makes it trustworthy. Built to last. Built to scale. Built to work alongside every institution, community and individual that wants to see this country thrive.
          </p>
          <p style={{ fontSize: 22, fontWeight: 900, color: "#C9A84C", lineHeight: 1.4 }}>
            We are not waiting. We are forging. Join us.
          </p>
        </div>
      </div>

      {/* CTA */}
      <section className="bp-cta" style={{ background: "#1B3A6B", textAlign: "center" }}>
        <h2 style={{ fontSize: "clamp(24px, 4vw, 40px)", fontWeight: 900, color: "#fff", margin: "0 0 14px", letterSpacing: "-0.02em" }}>
          Ready to <span style={{ color: "#C9A84C" }}>Forge</span> South Africa?
        </h2>
        <p style={{ color: "rgba(184,212,232,0.8)", fontSize: 15, margin: "0 auto 28px", maxWidth: 480 }}>
          Whether you are an individual, a community, a business or an institution, there is a place for you in this movement.
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button
            onClick={() => navigate("/register")}
            style={{ background: "#C9A84C", border: "none", borderRadius: 99, padding: "14px 32px", color: "#fff", fontWeight: 700, fontSize: 15, cursor: "pointer", fontFamily: "var(--font-body)" }}>
            Join the Movement
          </button>
          <button
            onClick={() => navigate("/howitworks")}
            style={{ background: "transparent", border: "1.5px solid rgba(184,212,232,0.4)", borderRadius: 99, padding: "14px 32px", color: "rgba(184,212,232,0.9)", fontWeight: 600, fontSize: 15, cursor: "pointer", fontFamily: "var(--font-body)" }}>
            How it works
          </button>
        </div>
        <div style={{ marginTop: 32, fontSize: 12, color: "rgba(184,212,232,0.35)" }}>
          Forge SA. Built by us. For us.
        </div>
      </section>

    </div>
  );
}